<template>
    <div>
        <v-container fluid grid-list-xl class="home-container general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar-medical-device></header-bar-medical-device>
                </v-flex>
            </v-layout>

            <div v-if="getChatBotScoringData" class="chat-bot-evaluation chat-bot-page-container chat-bot-evaluation-container">
                <div @scroll="handleConversationScroll"
                     v-if="movesScroll"
                     ref="scoringPagePf"
                         class="scrolling-content-scoring scrolling-content-scoring-chatbot scoring-page-pf padding-left-xxl padding-right-xxl">
                    <v-layout row wrap class="layout-scoring-page" >
                            <v-flex xs12>
                                <div v-if="getChatBotScoringData.hasScoringData === false" class="color-headings-text font-size-medium no-recommendation">
                                    <p v-if="!getAppPropertyStudyAccess"  class="no-margin-bottom">{{text("api.evaluation.noDecision")}}</p>


                                    <div v-if="getChatBotScoringData.notes !== null && getChatBotScoringData.notes.length > 0">
                                        <h4 class="headline-decision-h3">{{text('api.assessment.headline.notes')}}</h4>
                                        <div v-for="note in getChatBotScoringData.notes">
                                            <table class="note-table" role="presentation">
                                                <tr>
                                                    <td>
                                                        <h4 v-if="note.text"
                                                            v-html="note.text"
                                                            class="decision-headline di-headline">
                                                        </h4>
                                                        <p class="decision-text note-text"
                                                           v-if="note.description"
                                                           v-html="note.description">
                                                        </p>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <br/>
                                    </div>

                                    <br/>

                                    <v-expansion-panel>
                                        <v-expansion-panel-content
                                            v-if="getChatBotScoringData.comments && getChatBotScoringData.comments.commentTexts.length > 0"
                                            id="PANEL_COMMENTS"
                                            ref="COMMENTS"
                                            class="expansion-list chat-bot-evaluation-panels comments-container"
                                            value="1"
                                        >
                                            <div slot="header" class="color-headings-text chat-bot-evaluation-panel-title" v-if="getChatBotScoringData.comments.commentTexts">
                                                {{text('db.product.PROD_TITLE_RAT')}}
                                            </div>

                                            <div
                                                slot="actions"
                                                class="svg-wrapper"
                                                :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                                }"
                                            >
                                                <ExpandIcon v-if="getChatBotScoringData.displayedCodeSystems && !Object.keys(getChatBotScoringData.displayedCodeSystems).length > 0" :width="30" :height="30"/>
                                                <CollapseIcon v-else :width="30" :height="30"/>
                                            </div>


                                            <v-card v-if="getChatBotScoringData.comments">
                                                <v-card-text>
                                                    <table role="presentation">
                                                        <tr v-for="comment in getChatBotScoringData.comments.commentTexts"
                                                            v-if="comment && comment.length > 0"
                                                            :key="comment"
                                                            class="font-weight-regular no-margin-bottom">
                                                            <td class="comment-style">
                                                                <span>&#9679;</span>
                                                            </td>
                                                            <td class="evaluation-comment">
                                                                <span v-html="comment" ></span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <br/>

                                    <v-expansion-panel>
                                        <v-expansion-panel-content
                                            v-if="getChatBotScoringData.displayedCodeSystems && Object.keys(getChatBotScoringData.displayedCodeSystems).length > 0"
                                            value="1"
                                            id="PANEL_DIAGNOSIS_WARNING"
                                            ref="DIAGNOSIS_WARNING"
                                            class="expansion-list chat-bot-evaluation-panels recommendations-container"
                                        >
                                            <div slot="header" class="color-headings-text chat-bot-evaluation-panel-title">
                                                <div>
                                                    <h4 class="no-margin-bottom">{{text("api.summary.communication.codeSystem")}}</h4>
                                                </div>
                                            </div>
                                            <div
                                                slot="actions"
                                                class="svg-wrapper"
                                                :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                            }"
                                            >
                                                <ExpandIcon v-if="getChatBotScoringData.displayedCodeSystems && !Object.keys(getChatBotScoringData.displayedCodeSystems).length > 0" :width="30" :height="30"/>
                                                <CollapseIcon v-else :width="30" :height="30"/>
                                            </div>
                                            <v-card>
                                                <v-card-text>

                                                    <div class="diagnosis-warning">
                                                        <div class="diagnosis-warning-title">
                                                            <WarningIcon></WarningIcon>
                                                            <span>{{text("api.summary.communication.codeSystem.warning.label")}}</span>
                                                        </div>
                                                        <div class="diagnosis-warning-description">
                                                            <p>
                                                                {{text("api.summary.communication.codeSystem.warning.description")}}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div v-if="getChatBotScoringData.displayedCodeSystems && Object.keys(getChatBotScoringData.displayedCodeSystems).length > 0">
                                                        <div>
                                                            <div v-for="(codeSystem, key) in getChatBotScoringData.displayedCodeSystems"
                                                                 class="margin-bottom-s code-system-section"
                                                            >
                                                                <h4  v-if="codeSystem.name !== 'undefined' &&
                                                                                codeSystem.name !== null &&
                                                                                codeSystem.name.length > 0"
                                                                >
                                                                    {{codeSystem.name}}
                                                                </h4>
                                                                <div v-for="code in codeSystem.articles" class="code-system code-system-block code-system-block-pf">
                                                                    <div >
                                                                        <!--display code.name if code.commonName === null -->
                                                                        <h4 v-if="code.commonName !== null && code.commonName.length > 0"
                                                                            class="common-name-code-system common-name-code-system-pf">
                                                                            {{code.commonName}}
                                                                        </h4>
                                                                        <h4 v-else class="common-name-code-system common-name-code-system-pf">{{code.name}}</h4>
                                                                        <div class='likelihood' v-if="code.likelihood !== null">
                                                                             <div class='progress bg-color-primary' v-bind:style="{'width': code.likelihood + '%'}"></div>
                                                                        </div>
                                                                        <!--don't display code.name if code.commonName === null-->
                                                                        <p v-if="code.commonName !== null && code.commonName.length > 0 "
                                                                           class="code-system-article-name code-system-article-name-pf">
                                                                            {{code.name}}
                                                                        </p>
                                                                        <p class="code-system-description" v-html="code.commonDescription"></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>

                                    </v-expansion-panel>

                                    <!--- WARNING SECTION------->
                                    <!--- texts should be change with DB values--->

                                    <div v-if="getChatBotScoringData.noOtherSymptomsWarning || getChatBotScoringData.highlightedQuestionsAllAnsweredWarning || getChatBotScoringData.shortcutUsedWarning"
                                         class="warning-symptoms warning-section margin-top-s">
                                        <div class="warning-wrapper">
                                            <WarningIcon></WarningIcon>
                                            <span>{{text('db.product.PROD_PROPERTY_EVALUATION_WARNING_TITLE')}}</span>
                                        </div>

                                        <span>{{text('db.product.PROD_PROPERTY_EVALUATION_WARNING_DESCRIPTION')}}</span>
                                        <ul class="warning-list" style="margin-top: 5px;">
                                            <li style="margin-left: 20px" v-if="getChatBotScoringData.noOtherSymptomsWarning">
                                                {{text('db.product.PROD_PROPERTY_NO_OTHER_SYMPTOMS_WARNING')}}
                                            </li>

                                            <li style="margin-left: 20px" v-if="getChatBotScoringData.highlightedQuestionsAllAnsweredWarning">
                                                {{text('db.product.PROD_PROPERTY_HIGHLIGHTED_QUESTIONS_ALL_ANSWERED_WARNING')}}
                                            </li>

                                            <li style="margin-left: 20px" v-if="getChatBotScoringData.shortcutUsedWarning">
                                                {{text('db.product.PROD_PROPERTY_SHORTCUT_USED_WARNING')}}
                                            </li>
                                        </ul>
                                        <br/>
                                    </div>

                                </div>


                                <v-expansion-panel expand v-else>

                                    <v-expansion-panel-content
                                        id="PANEL_RECOMMENDATIONS"
                                        ref="RECOMMENDATIONS"
                                        v-if="getChatBotScoringData.decisions && getChatBotScoringData.hasScoringData" class="expansion-list chat-bot-evaluation-panels decisions-container" value="1">
                                        <div slot="header" class="color-headings-text chat-bot-evaluation-panel-title">
                                            {{text('db.product.PROD_SCORING')}}

                                            <!--{{scoringData.noOtherSymptomsWarning}}-->
                                            <!--{{scoringData.highlightedQuestionsAllAnsweredWarning}}-->
                                        </div>
                                        <div
                                            slot="actions"
                                            class="svg-wrapper"
                                            :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                                }"
                                        >
                                            <ExpandIcon v-if="!getIsPanelActive('RECOMMENDATIONS')" :width="30" :height="30"/>
                                            <CollapseIcon v-else :width="30" :height="30"/>
                                        </div>
                                        <v-card v-if="getChatBotScoringData.decisions">
                                            <v-card-text>
                                                <div v-if="getChatBotScoringData.decisions.decisionItem1"
                                                     :id="((getChatBotScoringData.decisions.decisionItem1.code) ? ('DI1_' + getChatBotScoringData.decisions.decisionItem1.code) : null)"
                                                     class="evaluation-decision-item">
                                                    <h4 class="chat-bot-evaluation-panel-headline">{{text('api.assessment.headline.di1.pfi')}}</h4>
                                                    <h4 v-if="getChatBotScoringData.decisions.decisionItem1.headline" v-bind:style="{'color': getDecisionItemColor(getChatBotScoringData.decisions.decisionItem1) }"
                                                        v-html="getChatBotScoringData.decisions.decisionItem1.headline"
                                                        :id="((getChatBotScoringData.decisions.decisionItem1.code) ? ('DI1_HEADLINE_' + getChatBotScoringData.decisions.decisionItem1.code) : null)"
                                                    >
                                                    </h4>
                                                    <p v-if="getChatBotScoringData.decisions.decisionItem1.text"
                                                       :id="((getChatBotScoringData.decisions.decisionItem1.code) ? ('DI1_TEXT_' + getChatBotScoringData.decisions.decisionItem1.code) : null)"
                                                       class="font-weight-regular"
                                                       v-html="getChatBotScoringData.decisions.decisionItem1.text"
                                                    ></p>
                                                </div>
                                                <div v-if="getChatBotScoringData.decisions.decisionItems2 !== null && getChatBotScoringData.decisions.decisionItems2 && getChatBotScoringData.decisions.decisionItems2.length > 0"
                                                     class="evaluation-decision-item">
                                                    <h4 class="chat-bot-evaluation-panel-headline">{{text('api.assessment.headline.di2.pfi')}}</h4>
                                                    <div v-for="decisionItem2 in getChatBotScoringData.decisions.decisionItems2"
                                                         :id="((decisionItem2.code) ? ('DI2_' + decisionItem2.code) : null)"
                                                    >
                                                        <h4
                                                            v-if="decisionItem2.headline"
                                                            :id="((decisionItem2.code) ? ('DI2_HEADLINE_' + decisionItem2.code) : null)"
                                                            v-bind:style="{'color': getDecisionItemColor(decisionItem2) }"
                                                            v-html="decisionItem2.headline">
                                                        </h4>
                                                        <p class="font-weight-regular no-margin-bottom">
                                                            <span v-if="decisionItem2.target === true" >
                                                                 <img src="../../../assets/svg/ambulance_alert_on.svg" alt="medicine logo" class="margin-left-xxs ambulance-scoring scoring-page" width="28" height="28">
                                                            </span>
                                                            <span v-html="decisionItem2.text" :id="((decisionItem2.code) ? ('DI2_TEXT_' + decisionItem2.code) : null)"></span>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div v-if="getChatBotScoringData.decisions && getChatBotScoringData.decisions.decisionItems3 !== null && getChatBotScoringData.decisions.decisionItems3 && getChatBotScoringData.decisions.decisionItems3.length > 0"
                                                    class="evaluation-decision-item"
                                                >
                                                    <h4 class="chat-bot-evaluation-panel-headline">{{text('api.assessment.headline.di3.pfi')}}</h4>
                                                    <div v-if="getChatBotScoringData.decisions.decisionItems3Recommended.length > 0" class="decision-item-header">
                                                        {{ text('api.assessment.headline.di3.pfi.recommended') }}
                                                    </div>
                                                    <div v-for="decisionItem3 in getChatBotScoringData.decisions.decisionItems3Recommended"
                                                         :id="((decisionItem3.code) ? ('DI3_REC_' + decisionItem3.code) : null)"
                                                         class="padding-left-s margin-bottom-s"
                                                    >
                                                        <h4 v-if="decisionItem3.headline"
                                                            :id="((decisionItem3.code) ? ('DI3_REC_HEADLINE_' + decisionItem3.code) : null)"
                                                            class="no-margin-bottom"
                                                            v-bind:style="{'color': getDecisionItemColor(decisionItem3) }"
                                                            v-html="decisionItem3.headline"
                                                        ></h4>
                                                        <p v-if="decisionItem3.text"
                                                           class="font-weight-regular no-margin-bottom"
                                                        >
                                                            <span v-html="decisionItem3.text" :id="((decisionItem3.code) ? ('DI3_REC_TEXT_' + decisionItem3.code) : null)"></span>
                                                        </p>
                                                    </div>

                                                    <div v-if="getChatBotScoringData.decisions && getChatBotScoringData.decisions.decisionItems3Possible.length > 0" class="decision-item-header">
                                                        {{ text('api.assessment.headline.di3.pfi.possible') }}
                                                    </div>
                                                    <div v-for="decisionItem3 in getChatBotScoringData.decisions.decisionItems3Possible"
                                                         :id="((decisionItem3.code) ? ('DI3_POS_' + decisionItem3.code) : null)"
                                                         class="padding-left-s margin-bottom-s"
                                                    >
                                                        <h4
                                                            v-if="decisionItem3.headline"
                                                            :id="((decisionItem3.code) ? ('DI3_POS_HEADLINE_' + decisionItem3.code) : null)"
                                                            class="no-margin-bottom"
                                                            v-bind:style="{'color': getDecisionItemColor(decisionItem3) }"
                                                            v-html="decisionItem3.headline">
                                                        </h4>
                                                        <p v-if="decisionItem3.text" class="font-weight-regular no-margin-bottom">
                                                            <span v-html="decisionItem3.text" :id="((decisionItem3.code) ? ('DI3_POS_TEXT_' + decisionItem3.code) : null)"></span>
                                                        </p>
                                                    </div>
                                                    <br/>
                                                </div>

                                                <div v-if="getChatBotScoringData.decisions && getChatBotScoringData.decisions.decisionItems4 !== null && getChatBotScoringData.decisions.decisionItems4 && getChatBotScoringData.decisions.decisionItems4.length > 0"
                                                     class="evaluation-decision-item">
                                                    <h4 class="chat-bot-evaluation-panel-headline">{{text('api.assessment.headline.di4.pfi')}}</h4>
                                                    <div v-if="getChatBotScoringData.decisions.decisionItems4Recommended.length > 0" class="decision-item-header">
                                                        {{ text('api.assessment.headline.di4.pfi.recommended') }}
                                                    </div>
                                                    <div v-for="decisionItem4 in getChatBotScoringData.decisions.decisionItems4Recommended"
                                                         :id="((decisionItem4.code) ? ('DI4_REC_' + decisionItem4.code) : null)"
                                                         class="padding-left-s margin-bottom-s"
                                                    >
                                                        <h4
                                                            v-if="decisionItem4.headline"
                                                            :id="((decisionItem4.code) ? ('DI4_REC_HEADLINE_' + decisionItem4.code) : null)"
                                                            class="no-margin-bottom"
                                                            v-bind:style="{'color': getDecisionItemColor(decisionItem4) }"
                                                            v-html="decisionItem4.headline"
                                                        >
                                                        </h4>
                                                        <p v-if="decisionItem4.text" class="font-weight-regular no-margin-bottom">
                                                            <span v-html="decisionItem4.text" :id="((decisionItem4.code) ? ('DI4_REC_TEXT_' + decisionItem4.code) : null)"></span>
                                                        </p>
                                                    </div>

                                                    <div v-if="getChatBotScoringData.decisions && getChatBotScoringData.decisions.decisionItems4Possible.length > 0" class="decision-item-header">
                                                        {{ text('api.assessment.headline.di4.pfi.possible') }}
                                                    </div>
                                                    <div v-if="getChatBotScoringData.decisions" v-for="decisionItem4 in getChatBotScoringData.decisions.decisionItems4Possible"
                                                         :id="((decisionItem4.code) ? ('DI4_POS_' + decisionItem4.code) : null)"
                                                         class="padding-left-s margin-bottom-s"
                                                    >
                                                        <h4
                                                            v-if="decisionItem4.headline"
                                                            :id="((decisionItem4.code) ? ('DI4_POS_HEADLINE_' + decisionItem4.code) : null)"
                                                            class="no-margin-bottom"
                                                            v-bind:style="{'color': getDecisionItemColor(decisionItem4) }"
                                                            v-html="decisionItem4.headline"
                                                        >
                                                        </h4>
                                                        <p v-if="decisionItem4.text" class="font-weight-regular no-margin-bottom">
                                                            <span v-html="decisionItem4.text" :id="((decisionItem4.code) ? ('DI4_POS_TEXT_' + decisionItem4.code) : null)"></span>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div v-if="getChatBotScoringData.notes !== null && getChatBotScoringData.notes.length > 0">
                                                    <h4 class="headline-decision-h3">{{text('api.assessment.headline.notes')}}</h4>
                                                    <div v-for="note in getChatBotScoringData.notes">
                                                        <table class="note-table" role="presentation">
                                                            <tr>
                                                                <td>
                                                                    <h4 v-if="note.text"
                                                                        v-html="note.text"
                                                                        class="decision-headline di-headline">
                                                                    </h4>
                                                                    <p class="decision-text note-text"
                                                                       v-if="note.description"
                                                                       v-html="note.description">
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>

                                                </div>

                                                <!--- WARNING SECTION------->
                                                <!--- texts should be change with DB values--->

                                                <div v-if="getChatBotScoringData.noOtherSymptomsWarning || getChatBotScoringData.highlightedQuestionsAllAnsweredWarning || getChatBotScoringData.shortcutUsedWarning"
                                                     class="warning-symptoms warning-section">
                                                    <div class="warning-wrapper">
                                                        <WarningIcon></WarningIcon>
                                                        <span>{{text('db.product.PROD_PROPERTY_EVALUATION_WARNING_TITLE')}}</span>
                                                    </div>

                                                    <span>{{text('db.product.PROD_PROPERTY_EVALUATION_WARNING_DESCRIPTION')}}</span>
                                                    <ul class="warning-list" style="margin-top: 5px;">
                                                        <li style="margin-left: 18px" v-if="getChatBotScoringData.noOtherSymptomsWarning">
                                                            {{text('db.product.PROD_PROPERTY_NO_OTHER_SYMPTOMS_WARNING')}}
                                                        </li>

                                                        <li style="margin-left: 18px" v-if="getChatBotScoringData.highlightedQuestionsAllAnsweredWarning">
                                                            {{text('db.product.PROD_PROPERTY_HIGHLIGHTED_QUESTIONS_ALL_ANSWERED_WARNING')}}
                                                        </li>

                                                        <li style="margin-left: 18px" v-if="getChatBotScoringData.shortcutUsedWarning">
                                                            {{text('db.product.PROD_PROPERTY_SHORTCUT_USED_WARNING')}}
                                                        </li>
                                                    </ul>
                                                    <br/>
                                                </div>

                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>


                                    <v-expansion-panel-content
                                        id="PANEL_RATIONALE"
                                        ref="RATIONALE"
                                        class="expansion-list chat-bot-evaluation-panels comments-container"  v-if="getChatBotScoringData.comments && getChatBotScoringData.hasScoringData && getChatBotScoringData.comments.commentTexts.length > 0" value="1">
                                        <div slot="header" class="color-headings-text chat-bot-evaluation-panel-title" v-if="getChatBotScoringData.comments.commentTexts">
                                            {{text('db.product.PROD_TITLE_RAT')}}
                                        </div>
                                        <div
                                            slot="actions"
                                            class="svg-wrapper"
                                            :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                                }"
                                        >
                                            <ExpandIcon v-if="!getIsPanelActive('RATIONALE')" :width="30" :height="30"/>
                                            <CollapseIcon v-else :width="30" :height="30"/>
                                        </div>
                                        <v-card>
                                            <v-card-text>
                                                <table role="presentation">
                                                    <tr v-for="comment in getChatBotScoringData.comments.commentTexts"
                                                        v-if="getChatBotScoringData.comments && comment && comment !== null && comment.length > 0"
                                                        :key="comment"
                                                        class="font-weight-regular no-margin-bottom">
                                                        <td class="comment-style">
                                                            <span>&#9679;</span>
                                                        </td>
                                                        <td class="evaluation-comment">
                                                            <span v-html="comment" ></span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>

                                    <v-expansion-panel-content
                                        id="PANEL_MEASURES"
                                        ref="MEASURES"
                                        class="expansion-list chat-bot-evaluation-panels recommendations-container"
                                                                   v-if="getChatBotScoringData.recommendations && getChatBotScoringData.hasScoringData
                                                                    && getChatBotScoringData.recommendations.recommendationsSections.length > 0" value="1">

                                            <div slot="header" class="color-headings-text chat-bot-evaluation-panel-title">
                                                {{text('db.product.PROD_TITLE_ADV')}}
                                            </div>
                                            <div
                                                slot="actions"
                                                class="svg-wrapper"
                                                :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                                }"
                                            >
                                            <ExpandIcon v-if="!getIsPanelActive('MEASURES')" :width="30" :height="30"/>
                                            <CollapseIcon v-else :width="30" :height="30"/>
                                        </div>
                                            <v-card>
                                                <v-card-text>

                                                    <div v-if="getChatBotScoringData.recommendations && getChatBotScoringData.recommendations.recommendationsSections">

                                                        <div v-for="recommendation in getChatBotScoringData.recommendations.recommendationsSections" class="chat-bot-recommendation">
                                                            <h4 v-if="recommendation.title && recommendation.recommendationsTexts" class="color-headings-text chat-bot-evaluation-panel-headline" v-html="recommendation.title"></h4>

                                                            <ul v-for="recommendationItem in recommendation.recommendationsTexts" class="font-weight-regular">
                                                                <li class="recommendationlist"
                                                                    v-if="recommendationItem.type === 'LIST_ITEM' && recommendationItem.text.length > 0"
                                                                    v-html="recommendationItem.text"></li>
                                                                <li v-else v-html="recommendationItem.text"></li>
                                                            </ul>
                                                        </div>

                                                    </div>

                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>

                                    <v-expansion-panel-content
                                        v-if="getChatBotScoringData.displayedCodeSystems !== null && Object.keys(getChatBotScoringData.displayedCodeSystems).length > 0"
                                        id="PANEL_POSSIBLE_CAUSES"
                                        ref="POSSIBLE_CAUSES"
                                        class="expansion-list chat-bot-evaluation-panels recommendations-container"
                                        value="1"
                                    >
                                            <div slot="header" class="color-headings-text chat-bot-evaluation-panel-title">
                                                <div>
                                                    <h4 class="no-margin-bottom">{{text("api.summary.communication.codeSystem")}}</h4>
                                                </div>
                                            </div>
                                            <div
                                            slot="actions"
                                            class="svg-wrapper"
                                            :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                                }"
                                        >
                                            <ExpandIcon v-if="!getIsPanelActive('POSSIBLE_CAUSES')" :width="30" :height="30"/>
                                            <CollapseIcon v-else :width="30" :height="30"/>
                                        </div>
                                            <v-card>
                                                <v-card-text>
                                                    <div v-if="getAppPropertyValue('CODING_SYSTEM_WARNING_DISPLAY') === 'true'" class="diagnosis-warning">
                                                        <div class="diagnosis-warning-title">
                                                            <WarningIcon></WarningIcon>
                                                            <span>{{text("api.summary.communication.codeSystem.warning.label")}}</span>
                                                        </div>
                                                        <div class="diagnosis-warning-description">
                                                            <p>
                                                                {{text("api.summary.communication.codeSystem.warning.description")}}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div v-if="getChatBotScoringData.displayedCodeSystems && Object.keys(getChatBotScoringData.displayedCodeSystems).length > 0">
                                                        <div>
                                                            <div v-for="(codeSystem, key) in getChatBotScoringData.displayedCodeSystems"
                                                                 :id="((codeSystem.type) ? ('CODE_SYSTEM_' + codeSystem.type) : null)"
                                                                 class="margin-bottom-s code-system-section"
                                                            >
                                                                    <h4 v-if="codeSystem.name !== 'undefined' &&
                                                                                codeSystem.name !== null &&
                                                                                codeSystem.name.length > 0"
                                                                        :id="((codeSystem.type) ? ('CODE_SYSTEM_NAME_' + codeSystem.type) : null)"
                                                                    >
                                                                        {{codeSystem.name}}
                                                                    </h4>
                                                                <div v-for="code in codeSystem.articles" class="code-system code-system-block code-system-block-pf">
                                                                    <div :id="((code.code) ? ('CODE_ARTICLE_' + code.code) : null)">
                                                                        <!--display code.name if code.commonName === null -->
                                                                        <h4 v-if="code.commonName !== null" class="common-name-code-system common-name-code-system-pf">
                                                                            {{code.commonName}}
                                                                        </h4>
                                                                        <h4 v-else class="common-name-code-system common-name-code-system-pf">
                                                                            {{code.name}}
                                                                        </h4>
                                                                        <div class='likelihood' v-if="code.likelihood !== null">
                                                                            <div class='progress bg-color-primary' v-bind:style="{'width': code.likelihood + '%'}"></div>
                                                                        </div>
                                                                        <!--don't display code.name if code.commonName === null-->
                                                                        <p v-if="code.commonName !== null" class="code-system-article-name code-system-article-name-pf">
                                                                            {{code.name}}
                                                                        </p>
                                                                        <p class="code-system-description" v-html="code.commonDescription"></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>

                                </v-expansion-panel>
                            </v-flex>
                        </v-layout>
                </div>



                <div ref="newAssessmentWrapper" class="new-assessment text-xs-center">

                    <div v-if="getVoucherData !== null && typeof getVoucherData.callbackUrl !== 'undefined' && getVoucherData.callbackUrl !== null
                                      && getAppPropertyValue('PATIENT_CONSENT') === 'true'" id="patient-consent-checkbox-wrapper">
                        <v-checkbox
                                    v-model="consentCheckboxValue"
                                    hide-details
                        ></v-checkbox>
                        <span @click="handleConsentCheckboxClick">{{text('api.chatbot.conversationMsg.patientConsent')}}</span>

                    </div>

                    <div class="new-assessment-btns">
                        <!--display share button also for Voucher -->
                        <v-btn v-if="(getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('PDF') > -1
                                || getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('EMAIL') > -1)"
                               @click="goToAssessmentSharePage"
                               id="btnSummaryShareAssessment"
                               flat round
                               class="text-transform-none component-bg-color-important color-primary"
                        >
                            {{text('api.button.header.bar.share')}}
                        </v-btn>

                        <v-btn v-if="getVoucherData === null && !getAppPropertyStudyAccess"
                               @click="goToHomePage"
                               id="btnSummaryStartNewAssessment"
                               flat round
                               class="text-transform-none component-bg-color-important color-primary"
                        >
                            <!-- {{text("api.chatbot.btn.newAssessment")}} -->
                            {{text('api.button.done')}}
                        </v-btn>
                        <v-btn v-else-if="getVoucherData !== null && typeof getVoucherData.callbackUrl !== 'undefined' && getVoucherData.callbackUrl !== null"
                               @click="submitConsentForm"
                               :disabled="consentCheckboxValue === false && getAppPropertyValue('PATIENT_CONSENT') === 'true'"
                               id="btnSummaryContinueToUrl"
                               flat round
                               class="text-transform-none"
                        >
                            {{text("api.button.continue")}}
                        </v-btn>
                    </div>


                    <transition name="more-content-fade">
                        <div class="more-content-button" v-if="getMoreContentAvailable" >
                            <a @click="scrollToBottom()">
                                <more-content class="more-content-icon"></more-content>
                            </a>
                        </div>
                    </transition>
                </div>

            </div>
        </v-container>

        <assessment-no-available-popup></assessment-no-available-popup>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import axios from 'axios';
import MoreContent from "../../../common/components/svg/shared/MoreContentIcon";
import HeaderBarMedicalDevice from "../../../pathfinder/components/shared/HeaderBarMedicalDevice";
import AssessmentNoAvailablePopup from "../shared/AssessmentNoAvailablePopup";
import ExpandIcon from "../../../common/components/svg/shared/ExpandIcon";
import CollapseIcon from "../../../common/components/svg/shared/CollapseIcon";
import Vue from "vue";
import WarningIcon from "../../../common/components/svg/shared/warningIcon.vue";
import Bowser from "bowser";


const SCORING_PANELS = {
        RECOMMENDATIONS: "RECOMMENDATIONS",
        RATIONALE: "RATIONALE",
        MEASURES: "MEASURES",
        POSSIBLE_CAUSES: "POSSIBLE_CAUSES",
        DIAGNOSIS_WARNING: "DIAGNOSIS_WARNING",
        COMMENTS: "COMMENTS"
    };

    export default {
        name: 'ChatBotEvaluationPage',
        components: {
            WarningIcon,
            CollapseIcon,
            ExpandIcon,
            HeaderBarMedicalDevice,
            MoreContent,
            AssessmentNoAvailablePopup
        },
        data () {
            return {
                clickIconMoreContent: false,
                movesScroll: false,
                consentCheckboxValue: false,
                isPanelActive: {
                    "RECOMMENDATIONS": true,
                    "RATIONALE": true,
                    "MEASURES": true,
                    "POSSIBLE_CAUSES": true,
                },
                checkBoxPlugin: Vue.CheckBox.checkBoxSvg
            }
        },
        computed: {
            ...mapGetters({
                getChatBotScoringData: 'ChatBotStore/getChatBotScoringData',
                getMoreContentAvailable: 'ChatBotStore/getMoreContentAvailable',
                getVoucherData: 'TranslationStore/getVoucherData',
                getVoucherCallbackData: 'TranslationStore/getVoucherCallbackData',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray',
                getIsThemeDarkActive : 'TranslationStore/getIsThemeDarkActive',
                getDecisionItemColor: 'ThemeStore/getDecisionItemColor',
                getAppPropertyStudyAccess: 'TranslationStore/getAppPropertyStudyAccess'
            }),

            isiOSDevice() {
                return /iPhone|iPad|Macintosh/.test(navigator.userAgent);
            },
            isIOS26OrLaterDevice() {
                const browser = Bowser.getParser(navigator.userAgent);
                const os = browser.getBrowserVersion();
                return this.compareVersions(os, "26.0") >= 0;
            },

            isIPad() {
                return /iPad|Macintosh/.test(navigator.userAgent);
            }
        },

        created() {
            this.$store.dispatch('ChatBotStore/loadChatBotScoringData').then(() => {
                function setCookie(name,value, days) {
                    let expires = "";
                    if (days) {
                        let date = new Date();
                        date.setTime(date.getTime() + (days*24*60*60*1000));
                        expires = "; expires=" + date.toUTCString();
                    }
                    document.cookie = name + "=" + (value || "")  + expires +"; path=/";
                }
                setCookie('showAssessmentAlert', 'yes', 366);

                this.registerPanelHeaderClicks();

                if (this.getVoucherData !== null && this.getVoucherCallbackData !== null) {
                    this.UtilitiesPlugin.createFormForData(this.getVoucherData.callbackUrl, this.getVoucherCallbackData.callbackDataMap, this.getAppPropertyValue('PATIENT_CONSENT'));
                }

                if (this.isiOSDevice) {
                    if (this.$refs.scoringPagePf && this.$refs.newAssessmentWrapper) {
                        const height = this.$refs.newAssessmentWrapper.offsetHeight + 10;
                        this.$refs.scoringPagePf.style.setProperty("padding-bottom", `${height}px`, "important");
                    }
                    // initial scroll to top
                    const el = document.scrollingElement || document.documentElement;
                    el.scrollTo({
                        top: 0,
                    });

                }
            });

            window.addEventListener('click', this.handleClicks);
        },
        destroyed() {
            window.removeEventListener('click', this.handleClicks);
            window.removeEventListener('scroll');
            document.documentElement.classList.remove('ios-fix');
            document.documentElement.classList.remove('ios-26-fix');
            document.documentElement.classList.remove('ipad-fix');
        },
        mounted() {
            this.movesScroll = true;
            let that = this
            setTimeout(function() {
                if (!that.isiOSDevice) {
                    that.callHeight()
                }
                else {
                    that.checkScroll();
                }
            }, 1500)

            let code = (function () {
                return {
                    getCookie: function (name) {
                        let value = "; " + document.cookie;
                        let parts = value.split("; " + name + "=");
                        if (parts.length === 2) {
                            return parts.pop().split(";").shift();
                        }
                    }
                }
            })();

            if (this.$router.currentRoute.path === '/pathfinder/chatbot-scoring') {
                history.pushState(null, null, location.href);
                window.onpopstate = function () {
                    if(code.getCookie('showAssessmentAlert') !== 'no') {
                        that.$store.commit('ChatBotStore/setMustShowAssessmentNoAvailablePopup', true);
                    }
                    history.go(1);
                };
            }

            if (this.isiOSDevice) {
                document.documentElement.classList.add('ios-fix');
                if (this.isIOS26OrLaterDevice) {
                    document.documentElement.classList.add('ios-26-fix');
                }
                // listen for scroll on html / body
                window.addEventListener("scroll", this.checkScroll, { passive: true });
            }
            if (this.isIPad) {
                document.documentElement.classList.add('ipad-fix');
            }
        },

        watch: {
            // We watch the consent checkbox to replace it with a svg when it is checked.
            consentCheckboxValue(newValue, oldValue) {
                if(newValue === true) {
                    let that = this;
                    setTimeout(function () {
                        let patientConsentCheckbox = document.querySelector('#patient-consent-checkbox-wrapper .input-group');
                        let iconCheckBox = patientConsentCheckbox.getElementsByClassName('icon--checkbox')
                        for (let j = 0; j < iconCheckBox.length; j++) {
                            iconCheckBox[j].innerHTML = that.checkBoxPlugin();
                        }
                    }, 10)
                }
            }
        },

        methods: {

            goToHomePage() {
                this.$router.push({name: 'PF_ChatBotPage'}).then(() => { // Go to Chatbot's home page (product list).
                    sessionStorage.removeItem("crtChatbotSection");
                    window.location.reload();
                });
            },

            compareVersions(v1, v2) {
                const parts1 = v1.split('.').map(Number);
                const parts2 = v2.split('.').map(Number);
                const len = Math.max(parts1.length, parts2.length);

                for (let i = 0; i < len; i++) {
                    const num1 = parts1[i] || 0;
                    const num2 = parts2[i] || 0;
                    if (num1 > num2) return 1;
                    if (num1 < num2) return -1;
                }
                return 0;
            },

            checkScroll() {
                let elemChatBotConversation = document.documentElement; // works on iOS Safari
                // visible height
                let clientHeight = elemChatBotConversation.clientHeight;

                // total scrollable height
                let scrollHeight = elemChatBotConversation.scrollHeight;

                // how far we've scrolled
                let scrollTop = elemChatBotConversation.scrollTop;

                let diffView = clientHeight + scrollTop;
                let bottomScroll = diffView / scrollHeight;

                if (bottomScroll >= 0.99) {
                    setTimeout(() => {
                        this.$store.commit('ChatBotStore/setMoreContentAvailable', false);
                        let iconToBottom = document.querySelectorAll('.more-content-icon');
                        for (let i = 0; i < iconToBottom.length; ++i) {
                            iconToBottom[i].classList.remove('opacityIcon');
                        }
                    }, 1);
                } else if (bottomScroll > 0.2 && bottomScroll < 0.99) {
                    this.$store.commit('ChatBotStore/setMoreContentAvailable', true);
                    let iconToBottom = document.querySelectorAll('.more-content-icon');
                    for (let i = 0; i < iconToBottom.length; ++i) {
                        iconToBottom[i].classList.add('opacityIcon');
                    }
                }
            },

            goToAssessmentSharePage() {
                this.$router.push({
                    name: "PF_ChatbotAssessmentSharePage"
                });
            },

            printPdf() {
                console.log("print pdf");
                let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/deliverPDF', {
                        assessmentToken: null,
                        pdfTemplateType: "PFI",
                        decisionItem1Label: null,
                        decisionItem1Color: null,
                        decisionItem2Label: null,
                        decisionItem2Icon: null,
                        decisionText: "",
                        disclaimer1: "",
                        disclaimer2: ""

                    },
                    {
                        responseType: 'arraybuffer',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/pdf'
                        }
                    });

                axiosRequest.then((response) => {
                    const attachment_name = response.headers["attachement-file-name"];

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), attachment_name); /* IE browser Solution*/
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', attachment_name); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                    }

                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },
            handleConversationScroll() {
                let elemChatBotConversation = document.querySelector(".scoring-page-pf");
                // is the pixels hidden in top due to the scroll. With no scroll its value is 0.
                //scrollHeight - is the pixels of the whole div.
                //clientHeight - is the pixels that you see in your browser.
                let diffView  = elemChatBotConversation.clientHeight + elemChatBotConversation.scrollTop;

                let bottomScroll = diffView / elemChatBotConversation.scrollHeight;

                if (bottomScroll >= 0.99) {
                    setTimeout(() => {
                        this.$store.commit('ChatBotStore/setMoreContentAvailable', false);
                        let iconToBottom = document.querySelectorAll('.more-content-icon');
                        for (let i = 0; i < iconToBottom .length; ++i) {
                            iconToBottom[i].classList.remove('opacityIcon');
                        }
                    }, 1)


                } else if (bottomScroll > 0.2 && bottomScroll < 0.99) {
                    // setTimeout(() => {
                    this.$store.commit('ChatBotStore/setMoreContentAvailable', true);
                    let iconToBottom = document.querySelectorAll('.more-content-icon');
                    for (let i = 0; i < iconToBottom .length; ++i) {
                        iconToBottom[i].classList.add('opacityIcon');
                    }
                    // }, 1)
                }

            },
            scrollToBottom() {
                if (this.isiOSDevice) {
                    const el = document.scrollingElement || document.documentElement;
                    el.scrollTo({
                        top: el.scrollHeight,
                        behavior: "smooth" // remove if you want instant jump
                    });
                }
                let elemChatBotConversation2 = document.querySelector(".scoring-page-pf");
                elemChatBotConversation2.scrollTop = elemChatBotConversation2.scrollHeight;

                this.clickIconMoreContent = true;
                setTimeout(() =>{
                    this.$store.commit('ChatBotStore/setMoreContentAvailable', false);
                    let iconToBottom =   document.querySelectorAll('.more-content-icon');

                    for (let i = 0; i < iconToBottom .length; ++i) {
                        iconToBottom[i].classList.add('opacityIcon');
                    }
                }, 1000)


            },
            callHeight() {
                let elemChatBotConversation = document.querySelector(".scoring-page-pf");
                // is the pixels hidden in top due to the scroll. With no scroll its value is 0.
                //scrollHeight - is the pixels of the whole div.
                //clientHeight - is the pixels that you see in your browser.
                if(elemChatBotConversation !== null) {
                    let diffView = elemChatBotConversation.clientHeight + elemChatBotConversation.scrollTop;

                    let bottomScroll = diffView / elemChatBotConversation.scrollHeight;


                    if (bottomScroll >= 0.99) {
                        setTimeout(() => {
                            this.$store.commit('ChatBotStore/setMoreContentAvailable', false);
                            let iconToBottom = document.querySelectorAll('.more-content-icon');
                            for (let i = 0; i < iconToBottom.length; ++i) {
                                iconToBottom[i].classList.remove('opacityIcon');
                            }
                        }, 1)


                    } else if (bottomScroll > 0.2 && bottomScroll < 0.99) {
                        // setTimeout(() => {
                        this.$store.commit('ChatBotStore/setMoreContentAvailable', true);
                        let iconToBottom = document.querySelectorAll('.more-content-icon');
                        for (let i = 0; i < iconToBottom.length; ++i) {
                            iconToBottom[i].classList.add('opacityIcon');
                        }
                        // }, 1)
                    }
                }
            },
            handleClicks(event) {
                let that = this;
                setTimeout(function() {
                    if (that.isiOSDevice) {
                        that.checkScroll();
                    }
                    else {
                        that.callHeight();
                    }
                    }, 500)
            },

            getIsPanelActive(panelReference) {
                return this.isPanelActive[panelReference];
            },
            onClickPanelHeader(event) {
                let panelReference = event.currentTarget.panelReference
                const panelRef = this.$refs[panelReference];

                this.$nextTick(()=> {
                    this.isPanelActive[panelReference] = panelRef.isActive;
                })
            },

            registerPanelHeaderClicks() {
                const recommendationsPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.RECOMMENDATIONS + ' .expansion-panel__header');
                if (recommendationsPanel)  {
                    recommendationsPanel.addEventListener('click', this.onClickPanelHeader, false);
                    recommendationsPanel.panelReference = SCORING_PANELS.RECOMMENDATIONS;
                }
                const rationalePanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.RATIONALE + ' .expansion-panel__header');
                if(rationalePanel) {
                    rationalePanel.addEventListener('click', this.onClickPanelHeader, false);
                    rationalePanel.panelReference = SCORING_PANELS.RATIONALE;
                }

                const measuresPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.MEASURES + ' .expansion-panel__header');
                if(measuresPanel)  {
                    measuresPanel.addEventListener('click', this.onClickPanelHeader, false);
                    measuresPanel.panelReference = SCORING_PANELS.MEASURES;
                }

                const possibleCausesPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.POSSIBLE_CAUSES + ' .expansion-panel__header');
                if(possibleCausesPanel) {
                    possibleCausesPanel.addEventListener('click', this.onClickPanelHeader, false);
                    possibleCausesPanel.panelReference = SCORING_PANELS.POSSIBLE_CAUSES;
                }

                const commentsPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.COMMENTS + ' .expansion-panel__header');
                if(commentsPanel) {
                    commentsPanel.addEventListener('click', this.onClickPanelHeader, false);
                    commentsPanel.panelReference = SCORING_PANELS.COMMENTS;
                }

                const diagnosisWarning = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.DIAGNOSIS_WARNING + ' .expansion-panel__header');
                if(diagnosisWarning) {
                    diagnosisWarning.addEventListener('click', this.onClickPanelHeader, false);
                    diagnosisWarning.panelReference = SCORING_PANELS.DIAGNOSIS_WARNING;
                }

            },

            handleConsentCheckboxClick() {
                this.consentCheckboxValue = !this.consentCheckboxValue;
            },

            submitConsentForm() {
                if (this.getAppPropertyValue('PATIENT_CONSENT') === 'true') {
                    let consentFormField = document.getElementById("consentFormId");
                    if (consentFormField != null) {
                        consentFormField.value = this.consentCheckboxValue;
                    } else {
                        console.warn("Unexpected error! Couldn't find consentFormId.");
                    }
                }

                this.UtilitiesPlugin.submitDataForm(true, this.consentCheckboxValue);
            }

        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/ChatBotEvaluationPage.vue